
import { defineComponent, ref } from 'vue';
import Child from './components/Child.vue';
export default defineComponent({
    name: 'App',
    components: {
        Child,
    },
    setup() {
        return {
            visible: ref(true),
            isShow: ref(true),
        }
    }
});
